import { lighten } from "@material-ui/core";

export const corporate = {
  red: '#DD0C29',
  blue: '#162031',
  grey: '#A8AFBA'
};

export const getGradient = (color: string) => {
  const fadeColor = lighten(color, 0.35);
  return `linear-gradient(180deg, ${fadeColor} 0%, ${color} 100%)`;
};
